import styled from "styled-components";
import { SkeletonProps } from "./types";

export const StyledSkeleton = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    ![
      "marginLeft",
      "marginRight",
      "marginTop",
      "marginBottom",
      "width",
      "height",
      "borderRadius",
    ].includes(prop),
})<SkeletonProps>`
  width: ${({ width }) => `${width}%`};
  height: ${({ height }) => `${height}px`};
  border-radius: ${({ borderRadius = 0 }) => `${borderRadius}px`};

  margin-left: ${({ marginLeft = 0 }) => `${marginLeft}px`};
  margin-right: ${({ marginRight = 0 }) => `${marginRight}px`};
  margin-top: ${({ marginTop = 0 }) => `${marginTop}px`};
  margin-bottom: ${({ marginBottom = 0 }) => `${marginBottom}px`};

  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite linear;

  @keyframes shimmer {
    from {
      background-position: 200% 0;
    }
    to {
      background-position: -200% 0;
    }
  }
`;
